var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCat6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#ECADA4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6101 23.6723C38.1701 23.6723 37.0001 24.8323 37.0001 26.2823C37.0001 26.6723 37.0901 27.0523 37.2601 27.4023L33.3401 31.3223L31.2801 24.6223C32.3901 23.7023 32.5401 22.0523 31.6201 20.9423C30.7001 19.8323 29.0501 19.6823 27.9401 20.6023C26.8301 21.5223 26.6801 23.1723 27.6001 24.2823C27.7001 24.4023 27.8101 24.5123 27.9401 24.6223L25.8801 31.3223L21.9601 27.4023C22.1301 27.0523 22.2201 26.6723 22.2201 26.2823C22.2301 24.8423 21.0601 23.6723 19.6201 23.6623C18.1801 23.6523 17.0101 24.8123 17.0001 26.2523C16.9901 27.5423 17.9401 28.6523 19.2201 28.8423L21.3601 39.0823C21.4601 39.5523 21.8801 39.8923 22.3601 39.8823H36.8801C37.3601 39.8923 37.7801 39.5523 37.8801 39.0823L39.9801 28.8423C41.4101 28.6623 42.4201 27.3723 42.2401 25.9423C42.0801 24.6223 40.9401 23.6423 39.6101 23.6723Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat6);
export default __webpack_public_path__ + "static/media/cat_6.52a2ad2739064d03bad0fe40edbab9fc.svg";
export { ForwardRef as ReactComponent };